import template from './azure-ad-conditions-builder.directive.html';

export class AzureAdConditionsBuilderCtrl {
	static $inject = ['$scope', '$timeout', 'mx.SolutionBuilderAgent.AzureAdConditionsService', 'mx.internationalization', 'mx.SolutionBuilderAgent.ConditionsBuilder.Enums'];

	$scope;
	$timeout;
	azureAdConditionsService;
	i18n;
	entityService;
	conditionsBuilderEnums;

	query;
	currentQuery = '';
	currentProperties = '';
	builder;

	// This constant is not documented. It was taken from error messages.
	aadConditionsLimit = 15;
	warningMessage;

	label;
	properties;
	form;

	constructor($scope, $timeout, azureAdConditionsService, i18n, conditionsBuilderEnums) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.azureAdConditionsService = azureAdConditionsService;
		this.i18n = i18n;
		this.conditionsBuilderEnums = conditionsBuilderEnums;
	}

	$onInit() {
		mx.components.FormControlControllerBase.call(this, this.$timeout);

		this.initBuilder(this.properties, this.query);

		this.warningMessage = new mx.components.Forms.ErrorMessage(
			`<div class="error-message_field-name">${this.label}</div><div class="error-message_error-text">${this.i18n.get(
				'components.form-validation.aadConditionsLimitWarning'
			)}</div>`,
			false,
			'warning'
		);

		this.form.addFormErrorMessage(this.warningMessage);

		this.$scope.$watch('vm.query', (newQuery) => {
			const builder = this.initBuilder(this.currentProperties, newQuery);
			const validationState = this.validateConditions(builder);
			this.handleWarningMessage(validationState.showWarning);
			this.handleErrorMessage(validationState);
		});

		this.$scope.$watchCollection('vm.properties', (newProperties) => {
			if (newProperties) {
				this.initBuilder(newProperties, this.currentQuery);
			}
		});
	}

	$onDestroy() {
		this.handleWarningMessage(false);
	}

	/* private */
	initBuilder(properties, query) {
		const isEqualQueries = query === this.currentQuery;
		const isEqualProperties = properties === this.currentProperties;

		if (isEqualQueries && isEqualProperties) {
			return this.builder;
		}

		this.currentProperties = properties;
		this.currentQuery = query;

		const builder = this.azureAdConditionsService.getBuilder(this.currentProperties, this.currentQuery);
		this.builder = builder;
		this.builder.onOutputChange = (output) => {
			this.currentQuery = output;
			this.query = output;
		};

		return builder;
	}

	/* private */
	handleWarningMessage(showWarning) {
		this.warningMessage.isActive = showWarning;
	}

	/* private */
	handleErrorMessage(validationState) {
		// Trick to refresh Error Message
		this.customValidation = { IsValid: true };
		if (!validationState.isValid) {
			setTimeout(() => {
				this.customValidation = {
					IsValid: false,
					ErrorMessage: this.i18n.getFormatted('components.form-validation.aadConditionsLimitError', validationState.conditionsAmount, this.aadConditionsLimit),
				};
			});
		}
	}

	/* private */
	validateConditions(group) {
		const state = group ? this.checkConditionsState(group) : null;
		return {
			isValid: state ? state.conditionsAmount <= this.aadConditionsLimit || !state.hasOr : true,
			showWarning: state ? state.conditionsAmount > this.aadConditionsLimit && !state.hasOr : false,
			conditionsAmount: state ? state.conditionsAmount : 0,
		};
	}

	/* private */
	checkConditionsState(group, hasOr) {
		const result = {
			conditionsAmount: group.conditions.length,
			hasOr: hasOr || [...group.conditions, ...group.groups].some((c) => c.logicOperator === this.conditionsBuilderEnums.ConditionLogicOperators.OR),
		};
		group.groups.forEach((g) => {
			const condState = this.checkConditionsState(g, result.hasOr);
			result.conditionsAmount += condState.conditionsAmount;
			result.hasOr = condState.hasOr || result.hasOr;
		});
		return result;
	}
}

export function AzureAdConditionsBuilderDirective() {
	const directive = new mx.components.FormControlBase(AzureAdConditionsBuilderCtrl);
	angular.extend(directive.require, {
		form: '?^form',
	});
	angular.extend(directive.bindToController, {
		properties: '@',
		query: '=?ngModel',
	});
	directive.template = template;
	return directive;
}

angular.module('mx.SolutionBuilderAgent').directive('mxAzureAdConditionsBuilder', AzureAdConditionsBuilderDirective);
